import type { ReactNode } from 'react';

export function ReportChartCard({
  title,
  subtitle,
  empty,
  emptyMessage = 'No data for the selected range.',
  toolbar,
  children
}: {
  title: string;
  subtitle?: string;
  empty?: boolean;
  emptyMessage?: string;
  toolbar?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="user-activity-report-card">
      <div className="user-activity-report-card__header">
        <div>
          <h3 className="ops-section-title" style={{ margin: 0 }}>
            {title}
          </h3>
          {subtitle ? (
            <p className="user-activity-report-card__subtitle">{subtitle}</p>
          ) : null}
        </div>
        {toolbar ? <div className="user-activity-report-card__toolbar">{toolbar}</div> : null}
      </div>
      <div className="user-activity-report-card__body">
        {empty ? (
          <div className="user-activity-report-card__empty">{emptyMessage}</div>
        ) : (
          children
        )}
      </div>
    </section>
  );
}
